import { useNavigate, useSearchParams } from "react-router-dom";
import { PillGroup } from "@/components/ci/overview-cells";

const TABS = [
  { label: "Catalog", value: "/ci/matrix" },
  { label: "Token Factory", value: "/ci/matrix/tofa" },
];

// Switches between the declared cross-restore matrix and the Token Factory recipes,
// keeping the chosen cryod tag and sha.
export function MatrixTabs({ current }: { current: string }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const carried = new URLSearchParams();
  const tag = searchParams.get("tag");
  const revision = searchParams.get("rev");
  // Catalog's ?tag=none means "no tag"; on Token Factory it would name a tag.
  if (tag && tag !== "none") carried.set("tag", tag);
  if (revision) carried.set("rev", revision);
  const query = carried.toString();
  return (
    <PillGroup
      options={TABS}
      value={current}
      onChange={(path) => navigate(query ? `${path}?${query}` : path)}
    />
  );
}
